import "./ReasonsForCallComponent.scss";
import { FC } from "react";
import ReasonsForCallComponentProps from "./ReasonsForCallComponentProps";
import { getColorForDashboard } from "../../../../utils/general_utils";

const ReasonsForCallComponent: FC<ReasonsForCallComponentProps> = ({ data, title }) => {
    //some random colors
    const sum = data.reduce((acc, item) => acc + item.count, 0);
    const sortData = data.sort((a, b) => b.count - a.count);
    const getEquivalent = (count: number) => ((count * 100) / sum).toFixed(2);
    return <div className="reasons_for_call_component">
        <h4 className="me-2">{title}</h4>
        {sortData.map((reason, index) => <div className="item_reason" key={index}>
            <div className="reason">{reason.name}</div>
            <div className="percentage_container">
                <div className="bar_percentage" style={{
                    width: getEquivalent(reason.count) + "%",
                    background: getColorForDashboard(index),
                }}></div>
                <div className="percentage">{getEquivalent(reason.count)}%</div>
            </div>
        </div>)}
    </div>
}

export default ReasonsForCallComponent;